import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import { useStateContext } from "@/components/state";

const Final = (props) => {
    const context = useStateContext();
    const { state } = context;

    return (
        <Wrapper {...props} header="Klart for innlevering">
            <div className="banner__image--animated mb-3 sm-mb-6">
                <img
                    decoding="async"
                    src="/static/images/mediating.webp"
                    alt="La oss komme i gang og løse krøllen!"
                />
            </div>

            { state?.scenes?.current === state?.scenes?.total &&
                <div style={{ textAlign: "center" }}>
                    <button
                        className={ ["form__submit"].join(" ") }
                        type="submit"
                        data-loading={ state?.conditions?.locked }
                        disabled={ state?.conditions?.locked || state?.conditions?.submitted }
                    >
                        <p>
                            { state?.conditions?.locked ? "Sender inn ..." : "Send inn skjema" }
                        </p>
                    </button>
                </div>
            }
        </Wrapper>
    );
};

export default Final;
